export default "__VITE_ASSET__BsRLVwer__";